<template>
  <div class="wrapper nav-open">
    <side-bar>
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template
        slot="links"
        v-if="layoutType === 'classroom' && classroom_dashboard"
      >
        <sidebar-item
          :link="{
            name: 'Classroom Dashboard',
            path: '/hilo/classroomDashboard',
            image: '/static/img/Classroom.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Back to Home',
            path: '/hilo/homeScreen',
            image: '/static/img/Return.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Curriculum',
            path: '/hilo/curriculumTemplates',
            image: '/static/img/Curriculum.svg',
          }"
        ></sidebar-item>
        <br />
        <sidebar-item
          v-for="month of months"
          v-bind:key="month.label"
          :link="{
            name: month.label + ' Class',
            path: '/hilo/classroomDashboard/month',
            image: '/static/img/letters/' + month.label[0] + '.svg',
            count: month.classList.length > 99 ? '+99' : month.classList.length,
          }"
          :class="[month.classList.length === 0 ? 'disabled' : '']"
        >
          <sidebar-item
            v-for="classObj of month.classList"
            v-bind:key="classObj.id"
            :link="{
              name:
                classObj.curriculum.program.name +
                ' ' +
                classObj.activeInstructor.user.lastName,
              path:
                '/hilo/classroomDashboard/adminClassView/' +
                classObj.id +
                '?month=' +
                month.label +
                '&curriculumId=' +
                classObj.curriculumId,
              image: '/static/img/Book.svg',
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Archive',
            path: '/hilo/classroomDashboard/archivedClasses',
            image: '/static/img/archive.svg',
          }"
        ></sidebar-item>
      </template>
      <template slot="links" v-else-if="layoutType === 'settings' && settings">
        <sidebar-item
          :link="{
            name: 'Back to Home',
            path: '/hilo/homeScreen',
            image: '/static/img/Return.svg',
          }"
        ></sidebar-item>
        <br />
        <sidebar-item
          :link="{
            name: 'Users',
            path: '/settings/usersSettings',
            image: '/static/img/SettingsUsers.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Permissions',
            path: '/settings/permissionSettings',
            image: '/static/img/LighLock.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'General',
            path: '/settings/generalSettings',
            image: '/static/img/SettingsGear.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Customization',
            path: '/settings/customizationSettings',
            image: '/static/img/SettingsSlider.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Connections',
            path: '/settings/connectionSettings',
            image: '/static/img/SettingsConnect.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Billing',
            path: '/settings/billingSettings',
            image: '/static/img/CreditCard.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Security',
            path: '/settings/securitySettings',
            image: '/static/img/SettingsShield.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Usage Stats',
            path: '/settings/usageSettings',
            image: '/static/img/Graph.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Tidy Up',
            path: '/settings/tidyUpSettings',
            image: '/static/img/TidyUp.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Content Directory',
            path: '/settings/contentDirectorySettings',
            image: '/static/img/ContentSettings.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Apps',
            path: '/settings/appSettings',
            image: '/static/img/Puzzle.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Cross Account Copier',
            path: '/settings/accountCopierSettings',
            image: '/static/img/Across.svg',
          }"
          coming-soon
        ></sidebar-item>
      </template>
      <template slot="links" v-else>
        <sidebar-item
          v-if="home"
          :link="{
            name: 'Dashboard',
            path: '/hilo/homeScreen',
            image: '/static/img/Dashboard.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="classroom_dashboard"
          :link="{
            name: 'Classroom Dashboard',
            path: '/hilo/classroomDashboard',
            image: '/static/img/Classroom.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="classroom_instructor"
          :link="{
            name: 'Classroom Instructor',
            path: '/hilo/classroomInstructor',
            image: '/static/img/Classroom.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="classroom_student"
          :link="{
            name: 'Classroom',
            path: '/hilo/classroomStudent',
            image: '/static/img/Classroom.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="classroom_student && singleStudentGradebook"
          :link="{
            name: 'Grade Book',
            path: '/hilo/singleStudentGradeBook',
            image: '/static/img/letters/A.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-else-if="classroom_dashboard"
          :link="{
            name: 'Grade Book',
            path: '/hilo/adminGradeBook',
            image: '/static/img/Student Male.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="flight_schedule"
          :link="{
            name: 'Schedule',
            path: '/hilo/schedule',
            image: '/static/img/Calendar.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="curriculum"
          :link="{
            name: 'Curriculum',
            path: '/hilo/curriculumTemplates',
            image: '/static/img/Curriculum.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="hilo_assist"
          :link="{
            name: 'Hilo Assist',
            path: '/hilo/hiloAI',
            image: '/static/img/Sparkling.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="aircraft"
          :link="{
            name: 'Aircraft',
            path: '/hilo/aircraft',
            image: '/static/img/Airport.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="reservations"
          :link="{
            name: 'Reservations',
            path: '/hilo/reservations',
            image: '/static/img/Bookmark.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="lender_dashboard"
          :link="{
            name: 'Lender Dashboard',
            path: '/hilo/lenderDashboard',
            image: '/static/img/Dashboard.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="lender_dashboard"
          :link="{
            name: 'Grade Book',
            path: '/hilo/lender/gradebook',
            image: '/static/img/Student Male.svg',
          }"
        ></sidebar-item>
        <!-- fix log book so it doesn't render when a lender is logged in -->
        <sidebar-item
          v-if="logbook & !lender_dashboard"
          :link="{
            name: 'Log Book',
            path: '/hilo/logbook',
            image: '/static/img/Book.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="crm"
          :link="{
            name: 'CRM',
            path: '/hilo/crm',
            image: '/static/img/CRM.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="checkride_dropdown"
          name="Checkride"
          :link="{ name: 'Checkride', image: '/static/img/ContactDetails.svg' }"
        >
          <sidebar-item
            v-if="checkride_schedule"
            :link="{
              name: 'Schedule',
              path: '/hilo/checkrideSchedule',
              image: '/static/img/Calendar.svg',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="checkride_dpe_contact_info"
            :link="{
              name: 'DPE Contact Info',
              path: '/hilo/dpeContactInfo',
              image: '/static/img/Bell.svg',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="checkride_dpe_contact_form"
            :link="{
              name: 'DPE Contact Form',
              path: '/hilo/dpeContactForm',
              image: '/static/img/Bell.svg',
            }"
            coming-soon
          ></sidebar-item>
        </sidebar-item>
        <!--        <sidebar-item-->
        <!--          v-if="connect"-->
        <!--          :link="{-->
        <!--            name: 'Connect',-->
        <!--            path: '/hilo/connect',-->
        <!--            image: '/static/img/Connect.svg',-->
        <!--          }"-->
        <!--        ></sidebar-item>-->
        <sidebar-item
          v-if="instructors"
          :link="{
            name: 'Instructors',
            path: '/hilo/instructors',
            image: '/static/img/Student Male.svg',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="students"
          :link="{
            name: 'Students',
            path: '/hilo/students',
            image: '/static/img/Student Male.svg',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="billing"
          :link="{
            name: 'Billing',
            path: '/hilo/billing',
            image: '/static/img/Payroll.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="chat"
          :link="{
            name: 'Messages',
            path: '/hilo/chat',
            image: '/static/img/Chat.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="task_manager"
          :link="{
            name: 'Task Manager',
            path: '/hilo/taskManager',
            image: '/static/img/Realtime.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="maintenance"
          :link="{
            name: 'Maintenance',
            path: '/hilo/maintenance',
            image: '/static/img/Maintenance.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="payroll"
          :link="{
            name: 'Payroll',
            path: '/hilo/instructorPayroll',
            image: '/static/img/Payroll.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="maps"
          :link="{
            name: 'Maps',
            path: '/hilo/maps',
            image: '/static/img/Map.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="weather"
          :link="{
            name: 'Weather',
            path: '/hilo/maps', // need to create a new page
            image: '/static/img/Cloud.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="reports"
          :link="{
            name: 'Reports',
            path: '/hilo/reports',
            image: '/static/img/Connect.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="masterclass"
          :link="{
            name: 'Masterclass',
            path: '/hilo/masterclass',
            image: '/static/img/Connect.svg',
          }"
          coming-soon
        ></sidebar-item>
        <sidebar-item
          v-if="hilo_admin_dashboard"
          :link="{
            name: 'Hilo Admin Dashboard',
            path: '/hilo/hiloAdminDashboard',
            image: '/static/img/Dashboard.svg',
          }"
        ></sidebar-item>
        <!--        Hide for v1; move to settings for v2-->
        <!--        <sidebar-item-->
        <!--          v-if="user_scopes"-->
        <!--          :link="{ name: 'User Scopes', path: '/users/authGroupsScopeAdmin' }"-->
        <!--        ></sidebar-item>-->
        <!--        <sidebar-item-->
        <!--          v-if="auth_groups"-->
        <!--          :link="{-->
        <!--            name: 'Authentication Groups',-->
        <!--            path: '/users/userAuthGroupsAdmin',-->
        <!--          }"-->
        <!--        ></sidebar-item>-->
      </template>
    </side-bar>
    <div class="main-panel" ref="mainPanel">
      <top-navbar></top-navbar>
      <notifications></notifications>
      <div class="scrollable-content">
        <dashboard-content />
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useLoginStore } from "@/stores/loginStore";
import ClassesAPIService from "../../../servicehandlers/ClassesAPIService";

const classesAPIService = new ClassesAPIService();
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
    UserMenu,
  },
  data() {
    return {
      home: false,
      classroom_dashboard: false,
      classroom_instructor: false,
      classroom_student: false,
      profile_student: false,
      profile_instructor: false,
      profile_technician: false,
      profile_dpe: false,
      maps: false,
      checkride_dropdown: false,
      checkride_schedule: false,
      checkride_dpe_contact_form: false,
      checkride_dpe_contact_info: false,
      task_manager: false,
      flight_schedule: false,
      chat: false,
      hilo_assist: false,
      aircraft: false,
      dispatch: false,
      logbook: false,
      lender_dashboard: false,
      hilo_admin_dashboard: false,
      instructors: false,
      students: false,
      crm: false,
      maintenance: false,
      reservations: false,
      reports: false,
      billing: false,
      masterclass: false,
      curriculum: false,
      weather: false,
      payroll: false,
      connect: false,
      users: false,
      user_scopes: false,
      auth_groups: false,
      settings: false,
      singleStudentGradebook: false,
      fullGradeBook: false,
      layoutType: "",
      months: [],
    };
  },
  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    scrollToTop() {
      this.$refs.mainPanel.scrollTop = 0;
    },
    changeLayout() {
      let path = this.$route.path;
      if (path.includes("classroomDashboard")) {
        this.layoutType = "classroom";
      } else if (path.includes("/settings")) {
        this.layoutType = "settings";
      } else {
        this.layoutType = "";
      }
    },
    generateMonthsArray() {
      const currentDate = new Date();
      const currentMonthIndex = currentDate.getMonth();

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const monthsArray = [];
      for (let i = 0; i < 12; i++) {
        const monthIndex = (currentMonthIndex - i + 12) % 12;
        let temp = {
          label: months[monthIndex],
          classList: [],
        };
        monthsArray.push(temp);
      }

      this.months = monthsArray;
    },
    getClasses() {
      return classesAPIService.get(this.$router).then((response) => {
        response.sort(
          (a, b) => a.curriculum.program.id - b.curriculum.program.id,
        );
        for (let classObj of response) {
          classObj.startDate = new Date(classObj.startDate);
          for (let month of this.months) {
            const monthName = classObj.startDate.toLocaleDateString("default", {
              month: "long",
            });
            if (monthName === month.label) {
              const now = new Date();
              const yearDiff =
                now.getFullYear() - classObj.startDate.getFullYear();
              let monthDiff = now.getMonth() - classObj.startDate.getMonth();

              monthDiff = yearDiff * 12 + monthDiff;

              if (monthDiff < 12) {
                month.classList.push(classObj);
              }
              break;
            }
          }
        }
      });
    },
  },
  watch: {
    $route() {
      this.scrollToTop();
      this.changeLayout();
    },
  },
  mounted() {
    const store = useLoginStore();
    for (const scope of store.appScopes) {
      if (scope.name === "home") {
        this.home = true;
      }
      if (scope.name === "maps") {
        this.maps = true;
      }
      if (scope.name === "classroom-dashboard") {
        this.classroom_dashboard = true;
      }
      if (scope.name === "classroom-instructor") {
        this.classroom_instructor = true;
      }
      if (scope.name === "classroom-student") {
        this.classroom_student = true;
      }
      if (scope.name === "profile-student") {
        this.profile_student = true;
      }
      if (scope.name === "profile-instructor") {
        this.profile_instructor = true;
      }
      if (scope.name === "profile-technician") {
        this.profile_technician = true;
      }
      if (scope.name === "profile-dpe") {
        this.profile_dpe = true;
      }
      if (scope.name === "checkride-dropdown") {
        this.checkride_dropdown = true;
      }
      if (scope.name === "checkride-schedule") {
        this.checkride_schedule = true;
      }
      if (scope.name === "checkride-dpe-contact-form") {
        this.checkride_dpe_contact_form = true;
      }
      if (scope.name === "checkride-dpe-contact-info") {
        this.checkride_dpe_contact_info = true;
      }
      if (scope.name === "task-manager") {
        this.task_manager = true;
      }
      if (scope.name === "flight-schedule") {
        this.flight_schedule = true;
      }
      if (scope.name === "chat") {
        this.chat = true;
      }
      if (scope.name === "hilo-assist") {
        this.hilo_assist = true;
      }
      if (scope.name === "aircraft") {
        this.aircraft = true;
      }
      if (scope.name === "dispatch") {
        this.dispatch = true;
      }
      if (scope.name === "logbook") {
        this.logbook = true;
      }
      if (scope.name === "lender-dashboard") {
        this.lender_dashboard = true;
      }
      if (scope.name === "hilo-admin-dashboard") {
        this.hilo_admin_dashboard = true;
      }
      if (scope.name === "instructors") {
        this.instructors = true;
      }
      if (scope.name === "students") {
        this.students = true;
      }
      if (scope.name === "crm") {
        this.crm = true;
      }
      if (scope.name === "maintenance") {
        this.maintenance = true;
      }
      if (scope.name === "reservations") {
        this.reservations = true;
      }
      if (scope.name === "reports") {
        this.reports = true;
      }
      if (scope.name === "billing") {
        this.billing = true;
      }
      if (scope.name === "masterclass") {
        this.masterclass = true;
      }
      if (scope.name === "curriculum") {
        this.curriculum = true;
      }
      if (scope.name === "weather") {
        this.weather = true;
      }
      if (scope.name === "payroll") {
        this.payroll = true;
      }
      if (scope.name === "connect") {
        this.connect = true;
      }
      if (scope.name === "users") {
        this.users = true;
      }
      if (scope.name === "user-scopes") {
        this.user_scopes = true;
      }
      if (scope.name === "auth-groups") {
        this.auth_groups = true;
      }
      if (scope.name === "settings") {
        this.settings = true;
      }
      if (scope.name === "single-student-gradebook") {
        this.singleStudentGradebook = true;
      }
      if (scope.name === "full-gradebooks") {
        this.fullGradeBook = true;
      }
    }
    this.initScrollbar();
    this.changeLayout();
    this.generateMonthsArray();
    this.getClasses();
  },
};
</script>

<style scoped>
/*noinspection CssUnusedSymbol */
.wrapper .sidebar-item {
  margin-top: 0;
}

/*noinspection CssUnusedSymbol */
.wrapper .sidebar-item:first-of-type {
  margin-top: 40px;
}

.main-panel {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/*noinspection CssUnusedSymbol */
.disabled {
  pointer-events: none;
}
</style>
